// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../bos/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../bos/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skeletonDocumentViewer .skeleton-box {
  width: 100%;
  height: 8vh;
}
.skeletonDocumentViewer .skeleton-preview-box {
  width: 100%;
  height: 47vh;
}
.skeletonDocumentViewer .skeleton-icons {
  width: 25px;
  height: 25px;
  float: right;
}`, "",{"version":3,"sources":["webpack://./../gui/src/components/Skeletons/skeletonStyles.scss"],"names":[],"mappings":"AAEE;EACE,WAAA;EACA,WAAA;AADJ;AAGE;EACE,WAAA;EACA,YAAA;AADJ;AAGE;EACE,WAAA;EACA,YAAA;EACA,YAAA;AADJ","sourcesContent":["// DocumentViewer\n.skeletonDocumentViewer {\n  .skeleton-box {\n    width: 100%;\n    height: 8vh;\n  }\n  .skeleton-preview-box {\n    width: 100%;\n    height: 47vh;\n  }\n  .skeleton-icons {\n    width: 25px;\n    height: 25px;\n    float: right;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
